<div class="date-selection">
  <label>{{ 'module.shared.excelDownloadWizard.dateRangeLabelText' | translate }}:</label>

  <div class="date-picker-range" *ngIf="useDatePicker">
    <mat-form-field class="date-picker label picker-spacing">
      <mat-label>{{ 'module.shared.excelDownloadWizard.startDateLabelText' | translate }}</mat-label>
      <input matInput readonly [matDatepicker]="picker1" [(ngModel)]="startDate" [min]="minDate" [max]="getMaxDate()" autocomplete="off" />
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="date-picker label picker-spacing">
      <mat-label>{{ 'module.shared.excelDownloadWizard.endDateLabelText' | translate }}</mat-label>
      <input matInput readonly [matDatepicker]="picker2" [(ngModel)]="endDate" [min]="getMinDate()" [max]="maxDate" autocomplete="off" />
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="date-range-dropdown" *ngIf="useWeekYearDropdown || useMonthYearDropdown || useYearDropdown">
    <div class="start-date">
      <label class="dropdown-label">{{ 'module.shared.excelDownloadWizard.startDateLabelText' | translate }}</label>
      <div class="date-filter">
        <app-dropdown class="app-dropdown" [value]="this.selectedStartWeek" *ngIf="useWeekYearDropdown">
          <app-dropdown-option class="dropdown-option" *ngFor="let week of startWeekOptions" [value]="week" (optionSelect)="selectStartWeek(week)">
            {{ week }}</app-dropdown-option
          >
        </app-dropdown>
        <app-dropdown class="app-dropdown" [value]="this.selectedStartMonth" *ngIf="useMonthYearDropdown">
          <app-dropdown-option class="dropdown-option" *ngFor="let month of startMonthOptions" [value]="month" (optionSelect)="selectStartMonth(month)">
            {{ month }}</app-dropdown-option
          >
        </app-dropdown>
        <app-dropdown class="app-dropdown" [value]="this.selectedStartYear">
          <app-dropdown-option class="dropdown-option" *ngFor="let year of startYearOptions" [value]="year" (optionSelect)="selectStartYear(year)">
            {{ year }}</app-dropdown-option
          >
        </app-dropdown>
      </div>
    </div>

    <div class="end-date">
      <label class="dropdown-label">{{ 'module.shared.excelDownloadWizard.endDateLabelText' | translate }}</label>
      <div class="date-filter">
        <app-dropdown class="app-dropdown" [value]="this.selectedEndWeek" *ngIf="useWeekYearDropdown">
          <app-dropdown-option class="dropdown-option" *ngFor="let week of endWeekOptions" [value]="week" (optionSelect)="selectEndWeek(week)">
            {{ week }}</app-dropdown-option
          >
        </app-dropdown>
        <app-dropdown class="app-dropdown" [value]="this.selectedEndMonth" *ngIf="useMonthYearDropdown">
          <app-dropdown-option class="dropdown-option" *ngFor="let month of endMonthOptions" [value]="month" (optionSelect)="selectEndMonth(month)">
            {{ month }}</app-dropdown-option
          >
        </app-dropdown>
        <app-dropdown class="app-dropdown" [value]="this.selectedEndYear">
          <app-dropdown-option class="dropdown-option" *ngFor="let year of endYearOptions" [value]="year" (optionSelect)="selectEndYear(year)">
            {{ year }}</app-dropdown-option
          >
        </app-dropdown>
      </div>
    </div>
  </div>

  <div class="year-dropdown-selection" *ngIf="useFixedYearRange">
    <app-dropdown class="app-dropdown" [value]="this.selectedYearRange">
      <app-dropdown-option class="dropdown-option" *ngFor="let year of fixedYearOptions" [value]="year" (optionSelect)="selectFixedYearRange(year)">
        {{ year }}</app-dropdown-option
      >
    </app-dropdown>
  </div>
</div>
